module.exports = __webpack_public_path__ + "img/f10.39f39c86.jpg";